import { jsx as d } from "react/jsx-runtime";
import { createContext as a, useState as s, useEffect as f, useLayoutEffect as p, useContext as T } from "react";
import '../../../styles/ThemeContext.css';const i = a(null), n = ["light", "dark"];
function C(t) {
  const {
    theme: e = "light",
    colors: h,
    children: m
  } = t;
  if (n.indexOf(e) === -1)
    throw new Error(`Theme ${e} is not supported, please check the supported themes list: [${n.join(", ")}]`);
  const [o, r] = s(e), [u, c] = s(h);
  f(() => {
    r(e);
  }, [e]), p(() => {
    document.documentElement.dataset.uikitTheme = o;
  }, [o]);
  const l = {
    theme: o,
    colors: u,
    setTheme: r,
    setColors: c
  };
  return /* @__PURE__ */ d(i.Provider, { value: l, children: m });
}
function E() {
  const t = T(i);
  if (!t)
    throw new Error("useTheme must be used within a ThemeProvider");
  return t;
}
export {
  C as ThemeProvider,
  E as useTheme
};
